export default "__VITE_ASSET__CuqBlSFb__"